module.exports = __webpack_public_path__ + "img/Louis-Image-03.8f6b226e.jpg";